module.exports = __webpack_public_path__ + "assets/img/logo.7c0010ae.png";